export default __webpack_public_path__ + "static/IBMPlexSans-Thin-Latin2-3da56f296758540520ce7b714606afdf.woff2";